import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useAuth } from '../context/AuthContext';

const SALES_EMAIL = 'sales@ajtechlabs.in';
const VISIBLE_ROLES = ['principal', 'school_admin'];

function daysUntil(dateStr) {
  if (!dateStr) return null;
  const diff = new Date(dateStr) - new Date();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

const PlanStatusBanner = () => {
  const { user, subscription } = useAuth();

  if (!user || !VISIBLE_ROLES.includes(user.role)) return null;
  if (!subscription) return null;

  const { plan_tier, status, trial_ends_at } = subscription;
  const trialDaysLeft = plan_tier === 'trial' ? daysUntil(trial_ends_at) : null;

  let level = null; // 'amber' | 'red'
  let message = '';

  if (status === 'suspended') {
    level = 'red';
    message = 'Your ClassTree account is suspended. Please contact support to restore access.';
  } else if (status === 'expired') {
    level = 'red';
    message = 'Your ClassTree subscription has expired. Contact us to renew.';
  } else if (plan_tier === 'trial' && status === 'active') {
    if (trialDaysLeft !== null && trialDaysLeft <= 0) {
      level = 'red';
      message = 'Your free trial has ended. Contact us to continue using ClassTree.';
    } else if (trialDaysLeft !== null && trialDaysLeft <= 7) {
      level = 'amber';
      message = `Your free trial ends in ${trialDaysLeft} day${trialDaysLeft === 1 ? '' : 's'}. Contact us to upgrade.`;
    }
  }

  if (!level) return null;

  const bg = level === 'red' ? '#fee2e2' : '#fef3c7';
  const fg = level === 'red' ? '#991b1b' : '#92400e';

  const mailtoHref = `mailto:${SALES_EMAIL}?subject=${encodeURIComponent(
    `ClassTree upgrade request — ${user.school?.name || ''}`
  )}`;

  return (
    <Box
      sx={{
        bgcolor: bg,
        color: fg,
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        flexWrap: 'wrap',
        zIndex: 1300,
      }}
    >
      <Typography variant="body2" fontWeight={600}>
        {message}
      </Typography>
      <Button
        size="small"
        variant="outlined"
        href={mailtoHref}
        sx={{ color: fg, borderColor: fg, '&:hover': { borderColor: fg, bgcolor: `${fg}10` } }}
      >
        Contact us
      </Button>
    </Box>
  );
};

export default PlanStatusBanner;
